module.exports = __webpack_public_path__ + "img/pizzaking-logo.b4fd59f7.svg";